import type { CurrentUser } from '@wundo/client/auth.ts';

/** For the admins of an organisation that has the Dashboard on; a superadmin keeps it for support. */
export function canSeeDashboard(user: CurrentUser): boolean {
  return user.dashboard_enabled && (user.role === 'admin' || user.role === 'superadmin');
}
